import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cost-modal" }

import { ref, computed, watch, onMounted } from 'vue'
import { oemUrl } from './const'
import AdditionCom from './addition/index.vue'
import micro from '@micro-zoe/micro-app'
import bus from '@/util/useBus'
import store, { isD2C } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'product', 'data', 'from', 'additionList', 'shipParam'],
  emits: ['update:visible', 'updateNum', 'close', 'updateAddition'],
  setup(__props, { emit }) {

const props = __props


const sonData: any = ref({})
const url = computed(() => {
  if (props.from === 'goods') {
    return oemUrl + 'oem/utility/Calculator/GoodsDetail?productCode=' + props.product.productCode
  }
  return oemUrl + 'oem/utility/Calculator/Plugin'
})
const additionComRef = ref()
const isAllCalUser = computed(() => store.state.route.isAllCalUser)
// 监听micro-app 的数据变化
const onChange = (data: any) => {
  sonData.value = data.detail.data?.data
  const { type, addition, noAdditionalFlag, isGroup, noSpot, product } = data.detail.data?.data
  console.log('micro-onChange-client', data)
  console.log('updateGoods', props.data)
  if (type === 'init') {
    micro.setData('my-app', {
      data: {
        type: 'updateGoods',
        isAllCal: isAllCalUser.value,
        systemSource: isD2C() ? 1 : 2,
        data: props.data,
        additionList: props.additionList,
        shipParam: props.shipParam
      }
    })
    return
  }
  if (['AdtOrder', 'DeliAdt'].includes(type)) {
    additionComRef.value.open({
      type,
      addition,
      noAdditionalFlag,
      isGroup,
      noSpot,
      product
    })
  }
  if (type === 'updateCart') {
    bus.emit('microappUpdateCart')
  }
}

const close = () => {
  emit('update:visible', false)
  emit('close')
}

const updateNum = () => {
  props.product.skuList.forEach((v: any) => {
    emit('updateNum', v)
  })
}
const handleAdt = (addition: any) => {
  emit('updateAddition', addition)
  micro.setData('my-app', {
    data: {
      addition: addition,
      type: sonData.value.type
    }
  })
}
watch(() => props.visible, (val) => {
  // 获取文档内容的高度
  const contentHeight = document.body.scrollHeight
  if (val) {
    if (contentHeight < 970) {
      // 才能滚动
      setTimeout(() => {
        document.getElementsByClassName('cost-calc-modal')[0].scrollIntoView()
      }, 60)
    }
  }
}
)

return (_ctx: any,_cache: any) => {
  const _component_micro_app = _resolveComponent("micro-app")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      "modal-class": "calculator-modal-no-mask-color",
      "model-value": __props.visible,
      width: "1140px",
      right: "16px",
      "destroy-on-close": "",
      onClosed: close,
      "custom-class": "cost-calc-modal",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_micro_app, {
            name: "my-app",
            url: _unref(url),
            onDatachange: onChange,
            destroy: ""
          }, null, 8, ["url"])
        ])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(AdditionCom, {
      ref: (_value, _refs) => {
        _refs['additionComRef'] = _value
        additionComRef.value = _value
      },
      onChange: handleAdt
    }, null, 512)
  ], 64))
}
}

})